import { Trans } from "@lingui/react/macro";
import type { IFilledButton } from "../Button/Button";
import { FilledButton } from "../Button/Button";
import ArrowUpIcon from "../icons/ArrowUpIcon";

type IRetrieveHistoryButton = StrictOmit<IFilledButton, "children">;

export const RetrieveHistoryButton = (props: IRetrieveHistoryButton) => {
  return (
    <FilledButton contentType="text-and-icon" {...props}>
      <ArrowUpIcon /> <Trans>Visa tidigare meddelanden</Trans>
    </FilledButton>
  );
};
